module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "listoffigures"
    }
  })]), _c('a', {
    attrs: {
      "id": "listoffigures"
    }
  }, [_c('h1', [_vm._v("LIST OF FIGURES")]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  })]), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "listoffigures"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/10_chap4#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1 Three-Fingered Front, Top View")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2 Three-Fingered Front, Near-Face View")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3 Three-Fingered Front, Side View")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4 Three-Fingered Front, Far-Face View")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5 More Contact With Ring Finger Than Index Finger")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6 Example of Hardways Set")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7 Example of Sevens Set")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8 Example of 3-V Set")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac843890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_figures.vue
// module id = 72
// module chunks = 0